<template>
  <div id="codemirror-container">
    <!-- 在模板中使用 CodeMirror 编辑器 -->
    <codemirror ref="cm" v-model="code" :options="options" />
  </div>
</template>

<script>
// 引入 CodeMirror 组件
import { codemirror } from 'vue-codemirror';
// 引入 CodeMirror 样式文件（可选）
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/monokai.css';
import 'codemirror/theme/panda-syntax.css';
import 'codemirror/theme/ayu-mirage.css';
import 'codemirror/theme/lucario.css';
import 'codemirror/theme/solarized.css';
import 'codemirror/theme/material.css';

import 'codemirror/mode/dockerfile/dockerfile';
import 'codemirror/mode/shell/shell';
import 'codemirror/mode/javascript/javascript';

export default {
  components: { codemirror },
  props: {
    value: {
      type: String,
      default: '',
      required: true
    },
    language: {
      type: String,
      default: 'shell'
    },
    theme: {
      type: String,
      default: 'material'
    },
    readOnly: {
      type: Boolean,
      default: false
    }
    // 可以扩展更多配置项的 props
  },
  data() {
    return {
      code: this.value,
      options: {
        // CodeMirror 配置项
        mode: this.language,
        lineNumbers: true,
        theme: this.theme, // 'panda-syntax'
        readOnly: this.readOnly
      }
    };
  },
  watch: {
    value(newVal) {
      this.code = newVal;
      this.$nextTick(() => {
        // 高度自适应
        // this.$refs.cm.codemirror.setSize('auto', '100%');
      });
    },
    code(newVal) {
      this.$emit('input', newVal);
    }
  }
};
</script>
<style lang="less">
#codemirror-container {
  .CodeMirror {
    height: auto !important;
    font-size: 13px;
  }
  .CodeMirror-scroll {
    height: auto !important; /*min-height: 100px;*/
    max-height: 100%;
    min-height: 160px;
  }
}
</style>
